import axios, {AxiosResponse} from 'axios';
import {AppConfig} from '@/app.config';
import {ICarList} from "@/modules/CarList/interfaces/car-list.interface";
import {AuthStore} from "@/modules/Auth/stores/auth.store";

class CarListResources {
  httpAction({ params, action }: { params: any, action?: any }) {
    return (axios.post(AppConfig.apiUrl, {
      action: action ? action : ICarList.Action.CarsMake,
      params,
      token: AuthStore.state.token,
      version: 1.0
    }) as Promise<AxiosResponse>);
  }

  httpActionMovements({ params }: { params: any }) {
    return (axios.post(AppConfig.apiUrl, {
      action: ICarList.Action.CarsMove,
      params,
      token: AuthStore.state.token,
      version: 1.0
    }) as Promise<AxiosResponse>);
  }
}

export const carListResources = new CarListResources();
